import exceptionTypes from './exception.types.js'

export default ['toastr', errorDelegationService]

function errorDelegationService(toastr) {
  this.handle = function handleError(error) {
    // Handling arity is always fun!
    if (exceptionTypes.ofReturnPacketType(error)) {
      throw new exceptionTypes.EllipsisException(error)
    } else if (
      exceptionTypes.ofValidationType(error) ||
      exceptionTypes.ofExceptionType(error) ||
      error instanceof Error
    ) {
      throw error
    } else {
      console.error(error)
    }
  }
}
